import React, { Component }  from 'react'
import { Icon, Modal, Button } from 'semantic-ui-react'
import FileInput from '../../components/FileInput/FileInput'

class StudentsReadCSV extends Component {
  render() {
    return (
      <Modal
        trigger={
          <Button icon labelPosition='left' color='green'> <Icon name='upload' />
          Import Students
          </Button>
        }
        onClose={() => this.props.setOpen(false)}
        onOpen={() => this.props.setOpen(true)}
        open={this.props.modalImportOpen}
        closeIcon
        >
        <Modal.Header>Import Students</Modal.Header>
        <Modal.Content>
            <FileInput
              handleFileChange={this.props.handleFileChange}
              className='students-file-input'
              error={false}
            />
        </Modal.Content>
        <Modal.Actions>
          <Button color='green' onClick={this.props.handleDataSave}>
            <Icon name='checkmark' /> Save
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
};

export default StudentsReadCSV;
